import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PersonalQPage4, { IProps } from './index';
import { InputFieldConfig } from '../../../../types';

const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    HasCriminalConvictions: hasCriminalConvictionsConfig,
    CriminalConvictionsReason: criminalConvictionsReasonConfig,
  }: {
    HasCriminalConvictions: InputFieldConfig;
    CriminalConvictionsReason: InputFieldConfig;
  } = state.student.config.Checklist.PersonalInfo.Page4;

  const {
    hasCriminalConvictions = (hasCriminalConvictionsConfig?.defaultValue || undefined) as boolean | undefined,
    criminalConvictionReason = criminalConvictionsReasonConfig?.defaultValue as string | undefined,
  } = state.student.personalInfo;

  const hasCriminalConvictionsVisible = hasCriminalConvictionsConfig?.visible ?? true;
  const criminalConvictionsReasonVisible =
    (criminalConvictionsReasonConfig?.visible ?? true) && hasCriminalConvictions === true;

  // prettier-ignore
  const complete =
    (!hasCriminalConvictionsVisible || !hasCriminalConvictionsConfig?.mandatory || hasCriminalConvictions !== undefined) &&
    (!criminalConvictionsReasonVisible || !criminalConvictionsReasonConfig?.mandatory ||  criminalConvictionReason !== '');

  return {
    sectionTitle: state.student.config.Checklist.PersonalInfo.shortTitle,
    complete,
    currentStep: 4,
    steps: 10,
    hasCriminalConvictions,
    hasCriminalConvictionsVisible,
    hasCriminalConvictionsConfig,
    criminalConvictionReason,
    criminalConvictionsReasonVisible,
    criminalConvictionsReasonConfig,
    config: state.student.config,
    isPageComplete: state.student.offer.isPIPage4Complete,
    importData: state.student.importData,
  };
};

export default connect(mapStateToProps)(PersonalQPage4);
